// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide_carousel__FHrh2 {
  border-radius: 15px;
  overflow: hidden;
}

.slide_inf__meAgl {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  height: 220px !important;
  border-radius: 15px;
}

.slide_inf2__fhfSI {
  background: linear-gradient(to right, #3d3393, #2b76b9, #2cacd1, #35eb93);
  height: 220px !important;
  border-radius: 15px;
}

.slide_inf3__1VB1z {
  background: linear-gradient(to right, #0250c5, #d43f8d);
  height: 220px !important;
  border-radius: 15px;
}

.slide_info__S-KzO {
  position: absolute;
  top: 10%;
  left: 12%;
  font-size: 3rem;
  color: white;
  font-weight: 700;
}

.slide_btn-info__Ar893 {
  color: white;
  font-size: 2.2rem;
  background-color: transparent;
  padding: 0 20px;
  border: solid 2px white;
  display: flex;
  justify-content: space-between;
}
.slide_btn-info__Ar893:hover {
  background-color: white;
  color: #0250c5;
}

.slide_git__eJTnq:hover {
  color: #d43f8d !important;
}

.slide_git1__FS-vN {
  color: white;
  font-size: 2.2rem;
  background-color: transparent;
  padding: 0 20px;
  border: solid 2px white;
  display: flex;
  justify-content: space-between;
}
.slide_git1__FS-vN:hover {
  color: #64480b !important;
  background-color: white;
}

/* global.css */
.slide_custom-carousel__t1cru .slide_carousel-inner__UxQmd {
  border-radius: 15px !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/content/post/slide/slide.module.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,gBAAA;AAAF;;AAGA;EAEI,sBAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;EACA,mBAAA;AADJ;;AAKA;EACI,yEAAA;EACA,wBAAA;EACA,mBAAA;AAFJ;;AAIA;EACI,uDAAA;EACA,wBAAA;EACA,mBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AADJ;;AAGA;EACI,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;AAAJ;AAEI;EACI,uBAAA;EACA,cAAA;AAAR;;AAII;EACI,yBAAA;AADR;;AAKA;EACI,YAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,8BAAA;AAFJ;AAGI;EACA,yBAAA;EACI,uBAAA;AADR;;AAOA,eAAA;AACA;EACQ,8BAAA;AAJR","sourcesContent":["\n.carousel {\n  border-radius: 15px;\n  overflow: hidden;\n}\n\n.inf{\n    // background: linear-gradient(to right,#FF1361, #ed6ea0, #ec8c69, );\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-position: center center;\n    height: 220px !important;\n    border-radius: 15px;\n\n    \n}\n.inf2{\n    background: linear-gradient(to right, #3d3393, #2b76b9, #2cacd1, #35eb93);\n    height: 220px !important;\n    border-radius: 15px;\n}\n.inf3{\n    background: linear-gradient(to right, #0250c5, #d43f8d);\n    height: 220px !important;\n    border-radius: 15px;\n}\n\n.info{\n    position: absolute;\n    top:10%;\n    left: 12%;;\n    font-size: 3rem;\n    color: white;\n    font-weight: 700;\n}\n.btn-info{\n    color: white;\n    font-size: 2.2rem;\n    background-color: transparent;\n    padding: 0 20px;\n    border: solid 2px white;\n    display: flex;\n    justify-content: space-between;\n\n    &:hover{\n        background-color: white;\n        color: #0250c5;\n    }\n}\n.git{\n    &:hover{\n        color: #d43f8d !important;\n\n    }\n}\n.git1{\n    color: white;\n    font-size: 2.2rem;\n    background-color: transparent;\n    padding: 0 20px;\n    border: solid 2px white;\n    display: flex;\n    justify-content: space-between;\n    &:hover{\n    color: #64480b !important;\n        background-color: white;\n\n\n    }\n}\n\n/* global.css */\n.custom-carousel .carousel-inner {\n        border-radius: 15px !important;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"carousel": `slide_carousel__FHrh2`,
	"inf": `slide_inf__meAgl`,
	"inf2": `slide_inf2__fhfSI`,
	"inf3": `slide_inf3__1VB1z`,
	"info": `slide_info__S-KzO`,
	"btn-info": `slide_btn-info__Ar893`,
	"git": `slide_git__eJTnq`,
	"git1": `slide_git1__FS-vN`,
	"custom-carousel": `slide_custom-carousel__t1cru`,
	"carousel-inner": `slide_carousel-inner__UxQmd`
};
export default ___CSS_LOADER_EXPORT___;
